import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// ============================================
// top MV news
// ============================================

function slider() {
  const swiper = new Swiper('.js-slider', {
    //direction: 'vertical',
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 1000,
    slidesPerView: 1.5,
    spaceBetween: 16,

    //レスポンシブ
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
    },

    //ページネーションボタン
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    //ナビボタン
    navigation: {
      nextEl: '.js-slider__next',
      prevEl: '.js-slider__prev',
    },

    //スクロールバー
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
    },
  });
}

// ============================================
// top MV
// ============================================

function mvSlider() {
  const mv = document.querySelector('.js-slider-mv');
  const slideNum = document.querySelectorAll('.p-index-mv__slide-num-item');

  if (mv && slideNum.length > 0) {
    const swiper = new Swiper(mv, {
      speed: 400,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function () {
          const index = this.realIndex;
          slideNum.forEach((item, i) => {
            item.classList.toggle('-current', i === index);
          });
        },
        init: function () {
          const index = this.realIndex;
          slideNum.forEach((item, i) => {
            item.classList.toggle('-current', i === index);
          });
        },
      },
    });
  }
}

// ============================================
//  TOP works箇所
// ============================================

function woksSlider() {
  const works = document.querySelector('.js-slider-works');
  if (works) {
    const swiper = new Swiper(works, {
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      speed: 1000,
      slidesPerView: 1.2,
      spaceBetween: 0,

      //レスポンシブ
      breakpoints: {
        768: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 0,
        },
      },

      //ナビボタン
      navigation: {
        nextEl: '.js-slider-works__next',
        prevEl: '.js-slider-works__prev',
      },
      //ページネーションボタン
      pagination: {
        el: '.js-slider-works__pagination',
        clickable: true,
      },
      on: {
        init: function () {
          adjustBars(works);
        },
      },
    });
    function adjustBars(works) {
      const bars = works.querySelectorAll('.swiper-pagination-bullet');
      if (!bars.length) return;
      bars.forEach((bar) => {
        bar.style.width = 100 / bars.length + '%';
      });
    }
  }
}

export { slider, woksSlider, mvSlider };
